import PopupMessage from "@/components/atoms/PopupMessage/PopupMessage";
import { CompareWidget } from "@/components/features/Compare/CompareWidget";
import { useCreditsIntro } from "@/components/features/Credits/useCreditsIntro";
import { useLoginParam } from "@/components/features/Login/useLoginParam";
import { AppWrapper } from "@/components/molecules/AppWrapper/AppWrapper";
import Footer from "@/components/molecules/Footer/Footer";
import { ModalController } from "@/components/molecules/Modals/ModalController";
import { ModalControllerV2 } from "@/components/molecules/Modals/ModalControllerV2";
import NavigationBar from "@/components/organisms/NavigationBar/NavigationBar";
import { MobileHeaderProvider } from "@/containers/MobileHeaderContext";
import { IosImportPopup } from "@/features/MyClub/IosImportPopup";
import { getMessageSelector } from "@/redux/message/messageSlice";
import { getUserSelector } from "@/redux/user/userSlice";
import { useSelector } from "react-redux";
import { Outlet, ScrollRestoration, useLocation } from "react-router";

export const RootLayout = () => {
  const { user } = useSelector(getUserSelector);
  const { message, modal } = useSelector(getMessageSelector);
  const location = useLocation();

  useCreditsIntro();
  useLoginParam();

  return (
    <div>
      <ScrollRestoration
        getKey={(location) => {
          // The "filter" param is in-page state (sidebar pane switches). Keep
          // it out of the scroll key: otherwise every filter value owns its own
          // saved scroll slot and switching panes replays stale positions —
          // preventScrollReset can't stop that, saved positions always win.
          const params = new URLSearchParams(location.search);
          params.delete("filter");
          const search = params.toString();
          return location.pathname + (search ? `?${search}` : "");
        }}
      />

      <div className="flex flex-col flex-start ">
        {message && (
          <PopupMessage
            title={message.title}
            content={message.content}
            fixed={message.fixed}
          />
        )}
        {modal &&
          (modal.modalType === "ios-import-popup" ? (
            <IosImportPopup />
          ) : (
            <ModalController
              modalType={modal?.modalType}
              premiumFeatureHook={modal?.premiumFeatureHook}
              freeFeatureLoggedInRequiredHook={
                modal?.freeFeatureLoggedInRequiredHook
              }
              upgradeTracking={modal?.upgradeTracking}
              data={modal?.data}
            />
          ))}
        <ModalControllerV2 />
        <MobileHeaderProvider>
          <AppWrapper isLoggedIn={!!user.uuid}>
            <NavigationBar currentRoute={location.pathname} />
            <Outlet />
            <CompareWidget />
          </AppWrapper>
        </MobileHeaderProvider>
        <Footer />
      </div>
    </div>
  );
};
